export const NOTIFICATION_EVENT = {
  SUBMITTED: "submitted",
  ENDORSED: "endorsed",
  APPROVED: "approved",
  REVISION_REQUEST: "revision_request",
  REUPLOADED: "reuploaded",
  ASSIGNED: "assigned",
  INFORMED_STUDENT: "informed_student",
  WORKFLOW_UPDATE: "workflow_update",
};
